import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import {
  TagContainer,
  TagLabel,
  TagInfo,
  TagHoverBox,
  PointerDiv,
  TagLabelAndInfoContainer,
} from './styledComponents';

export const Tags = ({
  items,
  isNestedContent = false,
  onlyLabel = false,
  labelCustomStyle = {},
}) => {
  if (_.isEmpty(items)) {
    return '-';
  }

  const sortedItems = items.sort();

  if (onlyLabel) {
    return (
      <>
        {sortedItems.map((item, index) => (
          <TagLabel className="box" key={index} style={labelCustomStyle}>
            {item}
          </TagLabel>
        ))}
      </>
    );
  }

  return (
    <TagContainer pointer={true}>
      <TagLabelAndInfoContainer>
        <TagLabel isNestedContent={isNestedContent}>{sortedItems[0]}</TagLabel>
        {sortedItems.length > 1 && <TagInfo as="TagInfo">{`+ ${sortedItems.length - 1}`}</TagInfo>}
      </TagLabelAndInfoContainer>
      <TagHoverBox>
        <PointerDiv />
        {sortedItems.map((item, index) => (
          <TagLabel className="box" key={index} style={labelCustomStyle}>
            {item}
          </TagLabel>
        ))}
      </TagHoverBox>
    </TagContainer>
  );
};

Tags.propTypes = {
  items: PropTypes.array.isRequired,
  isNestedContent: PropTypes.bool,
  onlyLabel: PropTypes.bool,
  labelCustomStyle: PropTypes.object,
};
